import { render, staticRenderFns } from "./ViewDraftItem.vue?vue&type=template&id=71e68902"
import script from "./ViewDraftItem.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewDraftItem.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports